<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-menu
            ref="menu1"
            v-model="menu"
            :close-on-content-click="false"
            lazy
            transition="scale-transition"
            :position-x="positionX"
            :position-y="positionY"
            absolute
            full-width
            max-width="290px"
            min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                    :value="dateFormatted"
                    :label="label"
                    persistent-hint
                    :rules="rules"
                    ref="textField"
                    @mousedown="handleMouseDown"
                    @click="handleClick"
                    @focus.stop="handleFocus"
                    @blur.stop="handleBlur"
                    @keydown.tab="handleTab"
            ></v-text-field>
        </template>
        <v-date-picker @change="handleOK" :value="value" v-on="$listeners" :min="min" :max="max">
        </v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        name: "DatePicker",
        props:{
            label: String,
            value: String,
            clearable:{type:Boolean, default:false},
            rules: Array,
            min: String,
            max: String
        },
        data: function(){
            return {
                menu: false,
                focused: false,
                mouseDown: false,
                okClicked: false,
                positionX: 0,
                positionY: 0,
            }
        },
        computed: {
            dateFormatted(){
                return this.formatDate(this.value)
            }
        },
        watch: {
            menu() {
                this.onResize();
            }
        },
        mounted() {
            window.addEventListener('resize', this.onResize);
        },

        methods: {
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}.${month}.${year}`
            },
            handleMouseDown() {
                if(!this.focused) {
                    this.mouseDown = true;
                }
            },
            handleClick() {
                this.mouseDown = false;
                this.menu=!this.menu;
            },
            handleFocus() {
                this.focused = true;
                if(this.okClicked) {
                    this.okClicked = false;
                }
                else if(!this.mouseDown) {
                    this.menu=true;
                }
            },
            handleBlur() {
                this.focused = false;
                this.mouseDown = false;
            },
            handleTab() {
                this.menu = false;
            },
            handleOK() {
                this.okClicked = true;
                this.$refs.textField.focus();
                this.menu = false;
            },
            onResize() {
                let bounds = this.$refs.textField.$refs.input.getBoundingClientRect();
                this.positionY = bounds.top + bounds.height;
                this.positionX = bounds.left;
            },
        }
    }
</script>

<style scoped>

</style>